export const createSnapshot = (context) => (id) => ({
    type: "CMS.SNAPSHOTS.CREATE",
    payload: { id },
    context,
});

export const restoreSnapshot = (context) => (id, from) => ({
    type: "CMS.SNAPSHOTS.RESTORE",
    payload: { id, from },
    context,
});

export const submitWebsite = (context) => (type, id) => ({
    type: "CMS.WEBSITES.SUBMIT",
    payload: { type, id },
    context,
});

export const exportWebsite = (context) => (id) => ({
    type: "CMS.WEBSITES.CREATE.EXPORT",
    payload: { id },
    context,
});

export const importWebsite = (context) => (name) => ({
    type: "CMS.WEBSITES.CREATE.IMPORT",
    payload: { name },
    context,
});

export const submitCreateWebsite = (context) => (id) => ({
    type: "CMS.WEBSITES.CREATE.SUBMIT",
    payload: { id },
    context,
});

export const destroyWebsite = (context) => (id) => ({
    type: "CMS.WEBSITES.DESTROY",
    payload: { id },
    context,
});

export const updateSchemaConfig = (context) => (id, data) => ({
    type: "CMS.WEBSITES.SCHEMA.UPDATE",
    payload: { id, data },
    context,
});

export const grantServiceAccess = (context) => (id, email) => ({
    type: "CMS.WEBSITES.ACCESS.GRANT",
    payload: { id, email },
    context,
});

export const blankCmsTranslations = (context) => (id, locales) => ({
    type: "CMS.TRANSLATIONS.BLANK",
    payload: { id, locales },
    context,
});

export const blankSeo = (context) => (id) => ({
    type: "CMS.SEO.BLANK",
    payload: { id },
    context,
});

export const copyCmsTranslations = (context) => (id, from, to) => ({
    type: "CMS.TRANSLATIONS.COPY",
    payload: { id, from, to },
    context,
});
